import * as ActionTypes from './types.action';

export const getPreviouslyPurchased = (page, params) => ({
  type: ActionTypes.GET_PREVIOUSLY_PURCHASED_REQUESTED,
  page,
  params,
});
